
import { Component, Vue, Prop } from "vue-property-decorator";
import { RawLocation } from "vue-router";
import { Getter } from 'vuex-class';

@Component({})
export default class AreaDetailsPopoutButton extends Vue {
    @Prop({ type: Number, default: 0 }) private groupId: number;
    @Prop({ type: String, default: "fas fa-external-link-alt" }) private icon: string;
    @Prop({ type: Boolean, default: false}) private disableHyperlinkStyle: boolean;

    @Getter("getFeature") getFeature: (featureName: string[]) => boolean;

    private get addAutopopulate(): boolean {
        return this.getFeature(["Areas", "AreaDetailsPopout", "AutopopulateEventArea"])
            && window.location.hash.includes("/site-monitor");
    }

	private openAreaInfo(groupID: number): void {
        let routeOptions: RawLocation = { name: 'area-info', params: { groupId: groupID.toString() } };

        if (this.addAutopopulate) {
            routeOptions.query = { autopopulate: 'true' };
        }
        const route = this.$router.resolve(routeOptions);
        window.open(route.href, 'AreaInfo', 'width=1000,height=600,noopener');
	}
}
